import PropTypes from "prop-types";
import EventCard from "../EventCard.jsx";

const OrganizerEventsList = ({
  events = [],
  upcomingEvents,
  previousEvents,
}) => {
  const now = Date.now();

  const formatCompactDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("sv-SE", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const normalizeEvent = (event) => ({
    ...event,
    name: event?.name || "Okänt evenemang",
    slug: event?.slug || "",
    date: event?.date || new Date().toISOString(),
    location: event?.location || "Plats ej angiven",
  });

  const validEvents = events
    .map(normalizeEvent)
    .filter((event) => Boolean(event.slug));

  const derivedUpcoming = validEvents
    .filter((event) => new Date(event.date).getTime() >= now)
    .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());

  const derivedPrevious = validEvents
    .filter((event) => new Date(event.date).getTime() < now)
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

  const upcomingList = Array.isArray(upcomingEvents)
    ? upcomingEvents.map(normalizeEvent).filter((event) => Boolean(event.slug))
    : derivedUpcoming;

  const previousList = Array.isArray(previousEvents)
    ? previousEvents.map(normalizeEvent).filter((event) => Boolean(event.slug))
    : derivedPrevious;

  return (
    <div className="space-y-10">
      <section>
        <h3 className="text-xl font-extrabold text-white uppercase tracking-wider mb-4">Kommande evenemang</h3>
        {upcomingList.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {upcomingList.map((event, index) => (
              <EventCard key={event.slug || index} event={event} />
            ))}
          </div>
        ) : (
          <p className="text-stone-400 text-sm">
            Inga kommande evenemang just nu.
          </p>
        )}
      </section>

      <section>
        <h3 className="text-xl font-extrabold text-white uppercase tracking-wider mb-4">Tidier evenemang</h3>
        {previousList.length > 0 ? (
          <div className="bg-[#131313] border border-white/10 rounded-2xl divide-y divide-white/5 overflow-hidden shadow-lg">
            {previousList.map((event, index) => (
              <a
                key={event.slug || index}
                href={`/events/${event.slug}`}
                className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 px-6 py-4 hover:bg-neutral-900/60 transition-all duration-200 group border border-transparent hover:border-white/5"
              >
                <p className="font-extrabold text-sm sm:text-base text-white uppercase tracking-wide group-hover:text-[#0047ff] transition-colors">{event.name}</p>
                <p className="text-xs font-semibold text-stone-400">
                  {formatCompactDate(event.date)}
                  {event.location ? ` - ${event.location}` : ""}
                </p>
              </a>
            ))}
          </div>
        ) : (
          <p className="text-stone-400 text-sm">
            Inga tidigare evenemang att visa.
          </p>
        )}
      </section>
    </div>
  );
};

OrganizerEventsList.propTypes = {
  events: PropTypes.arrayOf(PropTypes.object),
  upcomingEvents: PropTypes.arrayOf(PropTypes.object),
  previousEvents: PropTypes.arrayOf(PropTypes.object),
};

export default OrganizerEventsList;
